module.exports = __webpack_public_path__ + "img/logoVC.600e9c4e.png";